import { TextareaHTMLAttributes, useEffect, useRef } from 'react';
import autosize from 'autosize';
import * as Styles from './Textarea.styles';

type TextAreaType = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  name: string;
  errorMessage?: string;
};

export default function Textarea({ label, errorMessage, ...props }: TextAreaType): JSX.Element {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    autosize(textareaRef.current);
  }, []);

  return (
    <Styles.Box hasError={!!errorMessage}>
      {!!label && <Styles.Label>{label}</Styles.Label>}
      <Styles.TextArea ref={textareaRef} {...props} />
      {errorMessage && <Styles.CustomWarningMessage errorMessage={errorMessage} />}
    </Styles.Box>
  );
}
